/**
 * StaffToLead. Build 23 (Daniel 2026-09-18).
 *
 * "This deal is now closed but Rachelle can't go into the portal to see it.
 * Can we give her access to be able to see this once she clicks on it?"
 *
 * The lender nudge emails carry an "Update in the portal" button pointing at
 * /pre-approvals, which is the LENDER's own portal page and is gated to
 * partner logins. Staff who click it (ops watching the shared inbox, the
 * agent checking on a hand-off) were bounced to the dashboard with no
 * explanation, which reads as "I don't have access to this deal."
 *
 * They do have access. Owner, operations and admin already see every lead on
 * the team, and the agent sees their own. What they do not have is a lender
 * login, and they should not need one: the lead page carries the same facts
 * (buyer, lender, pre-approval status, the lender chat) plus everything else
 * about the deal, and it keeps working after the lead closes, which the
 * lender board deliberately does not.
 *
 * So this is a redirect, not a permission change. Nothing new is exposed:
 * the lead page applies the same visibility rule it always has, and a lender
 * still lands on their own portal exactly as before.
 */
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export default function StaffToLead({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  // The lender links carry the LEAD id, so /pre-approvals/123 and /leads/123
  // are the same record. Without one we can only offer the list.
  const { id } = useParams();

  // Hydrating. Render nothing rather than redirecting on a guess, the same
  // rule RequireAuth follows.
  if (loading) return null;
  if (user?.portal === 'agent') {
    return <Navigate to={id ? `/leads/${id}` : '/leads'} replace />;
  }
  return <>{children}</>;
}
